import React from "react";
import "./VerticalStepper.scss";

const VerticalStepper = ({ steps, activeIndex, onStepClick }) => {
  return (
    <div className="vertical-stepper">
      {steps.map((step, index) => {
        const isActive = index === activeIndex;
        const isCompleted = index < activeIndex;
        const isDisabled = step.disabled;
        const isClickable = !isDisabled && onStepClick;

        return (
          <div
            key={index}
            className={`stepper-step ${isActive ? "active" : ""} ${
              isCompleted ? "completed" : ""
            } ${isDisabled ? "disabled" : ""} ${isClickable ? "clickable" : ""}`}
            onClick={isClickable ? () => onStepClick(index) : undefined}
          >
            <div className="step-connector">
              <div className="step-number">
                {isCompleted ? (
                  <i className="pi pi-check" />
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>
              {index < steps.length - 1 && (
                <div className="step-line" />
              )}
            </div>
            <div className="step-content">
              <div className="step-label">{step.label}</div>
              {step.description && (
                <div className="step-description">{step.description}</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VerticalStepper;
